export enum EmbedMessageToParentStatus {
  OnLoad = 'ONLOAD',
  Error = 'ERROR',
  SessionExpired = 'SESSION_EXPIRED'
}

export interface IEmbedMessageToParent {
  status: EmbedMessageToParentStatus;
  response: {
    message: string;
  };
}

export enum EmbedSessionStatus {
  Inactive,
  Active,
  Invalid,
  Expired
}
